import RequestError from "@mittwald/api-client/dist/RequestError";
import UnexpectedResponseError from "@mittwald/api-client/dist/UnexpectedResponseError";
import ExtendedError from "../errors/ExtendedError";
import isError from "../errors/isError";
export class ResourceLoadingError extends ExtendedError {
    type;
    observers = new Set();
    constructor(type, cause) {
        const causeString = cause && typeof cause === "string" ? `: ${cause}` : "";
        super({ cause: isError(cause) ? cause : null }, `${type} error while loading resource${causeString}`);
        this.type = type;
        this.name = `${type}ResourceLoadingError`;
        Object.setPrototypeOf(this, ResourceLoadingError.prototype);
    }
    static fromError(error) {
        if (error && error instanceof ResourceLoadingError) {
            return error;
        }
        return undefined;
    }
    onResolved(handler) {
        this.observers.add(handler);
        return () => {
            this.observers.delete(handler);
        };
    }
    get isObserved() {
        return this.observers.size > 0;
    }
    notifyResolved() {
        this.observers.forEach((handler) => {
            try {
                handler();
            }
            catch (error) {
                throw this.extendError(error);
            }
        });
    }
    extendError(error) {
        if (isError(error)) {
            return new ExtendedError(error, `Error while calling onResolved callback handler for error type '${this.type}'`);
        }
        return error;
    }
}
export class NoAccessResourceLoadingError extends ResourceLoadingError {
    constructor(cause) {
        super("NoAccess", cause);
        Object.setPrototypeOf(this, NoAccessResourceLoadingError.prototype);
    }
}
export class NotFoundResourceLoadingError extends ResourceLoadingError {
    constructor(cause) {
        super("NotFound", cause);
        Object.setPrototypeOf(this, NotFoundResourceLoadingError.prototype);
    }
}
export class UnexpectedResourceLoadingError extends ResourceLoadingError {
    isCausedByRequestError;
    isCausedByServerError;
    constructor(cause) {
        super("Unexpected", cause);
        Object.setPrototypeOf(this, UnexpectedResourceLoadingError.prototype);
        this.isCausedByRequestError = cause instanceof RequestError;
        this.isCausedByServerError =
            cause instanceof UnexpectedResponseError && cause.isServerError;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVzb3VyY2VMb2FkaW5nRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcmVzb3VyY2VzL1Jlc291cmNlTG9hZGluZ0Vycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sWUFBWSxNQUFNLHdDQUF3QyxDQUFDO0FBQ2xFLE9BQU8sdUJBQXVCLE1BQU0sbURBQW1ELENBQUM7QUFDeEYsT0FBTyxhQUFhLE1BQU0seUJBQXlCLENBQUM7QUFDcEQsT0FBTyxPQUFPLE1BQU0sbUJBQW1CLENBQUM7QUFHeEMsTUFBTSxPQUFnQixvQkFBcUIsU0FBUSxhQUFhO0lBQzlDLElBQUksQ0FBUztJQUNaLFNBQVMsR0FBRyxJQUFJLEdBQUcsRUFBK0IsQ0FBQztJQUVwRSxZQUFzQixJQUFZLEVBQUUsS0FBZTtRQUNqRCxNQUFNLFdBQVcsR0FBRyxLQUFLLElBQUksT0FBTyxLQUFLLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxLQUFLLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUM7UUFFM0UsS0FBSyxDQUNILEVBQUUsS0FBSyxFQUFFLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFDeEMsR0FBRyxJQUFJLGdDQUFnQyxXQUFXLEVBQUUsQ0FDckQsQ0FBQztRQUVGLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ2pCLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxJQUFJLHNCQUFzQixDQUFDO1FBRTFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLG9CQUFvQixDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQzlELENBQUM7SUFFTSxNQUFNLENBQUMsU0FBUyxDQUFDLEtBQWU7UUFDckMsSUFBSSxLQUFLLElBQUksS0FBSyxZQUFZLG9CQUFvQixFQUFFLENBQUM7WUFDbkQsT0FBTyxLQUFLLENBQUM7UUFDZixDQUFDO1FBRUQsT0FBTyxTQUFTLENBQUM7SUFDbkIsQ0FBQztJQUVNLFVBQVUsQ0FBQyxPQUFvQztRQUNwRCxJQUFJLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUU1QixPQUFPLEdBQUcsRUFBRTtZQUNWLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ2pDLENBQUMsQ0FBQztJQUNKLENBQUM7SUFFRCxJQUFXLFVBQVU7UUFDbkIsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksR0FBRyxDQUFDLENBQUM7SUFDakMsQ0FBQztJQUVNLGNBQWM7UUFDbkIsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsRUFBRTtZQUNqQyxJQUFJLENBQUM7Z0JBQ0gsT0FBTyxFQUFFLENBQUM7WUFDWixDQUFDO1lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztnQkFDZixNQUFNLElBQUksQ0FBQyxXQUFXLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDaEMsQ0FBQztRQUNILENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVPLFdBQVcsQ0FBQyxLQUFjO1FBQ2hDLElBQUksT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7WUFDbkIsT0FBTyxJQUFJLGFBQWEsQ0FDdEIsS0FBSyxFQUNMLG1FQUFtRSxJQUFJLENBQUMsSUFBSSxHQUFHLENBQ2hGLENBQUM7UUFDSixDQUFDO1FBRUQsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0NBQ0Y7QUFFRCxNQUFNLE9BQU8sNEJBQTZCLFNBQVEsb0JBQW9CO0lBQ3BFLFlBQW1CLEtBQWU7UUFDaEMsS0FBSyxDQUFDLFVBQVUsRUFBRSxLQUFLLENBQUMsQ0FBQztRQUN6QixNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSw0QkFBNEIsQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUN0RSxDQUFDO0NBQ0Y7QUFFRCxNQUFNLE9BQU8sNEJBQTZCLFNBQVEsb0JBQW9CO0lBQ3BFLFlBQW1CLEtBQWU7UUFDaEMsS0FBSyxDQUFDLFVBQVUsRUFBRSxLQUFLLENBQUMsQ0FBQztRQUN6QixNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSw0QkFBNEIsQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUN0RSxDQUFDO0NBQ0Y7QUFFRCxNQUFNLE9BQU8sOEJBQStCLFNBQVEsb0JBQW9CO0lBQ3RELHNCQUFzQixDQUFVO0lBQ2hDLHFCQUFxQixDQUFVO0lBRS9DLFlBQW1CLEtBQWU7UUFDaEMsS0FBSyxDQUFDLFlBQVksRUFBRSxLQUFLLENBQUMsQ0FBQztRQUMzQixNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSw4QkFBOEIsQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUN0RSxJQUFJLENBQUMsc0JBQXNCLEdBQUcsS0FBSyxZQUFZLFlBQVksQ0FBQztRQUM1RCxJQUFJLENBQUMscUJBQXFCO1lBQ3hCLEtBQUssWUFBWSx1QkFBdUIsSUFBSSxLQUFLLENBQUMsYUFBYSxDQUFDO0lBQ3BFLENBQUM7Q0FDRiJ9